<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-3">Riwayat Withdrawal Tunai</div>
		<div class="text-xs mb-8">
			<Breadcrumbs />
		</div>

		<!-- table -->
		<div>
			<table class="table-new">
				<thead>
					<tr>
						<th>Date</th>
						<th>Transaction ID</th>
						<th>Amount</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="balanceHistory.length <= 0">
						<tr>
							<td colspan="3" class="text-center">
								<div class="text-1.5xl font-bold">Belum Ada Data</div>
								<div>Anda belum memiliki riwayat deposit</div>
							</td>
						</tr>
					</template>
					<template v-else>
						<tr v-for="(item, index) in balanceHistory" :key="index">
							<td class="text-center">{{ item.date }}</td>
							<td class="text-center">{{ item.transactionId }}</td>
							<td class="text-center">{{ item.amount }}</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import api from '../../api/axios.js'
import Decimal from 'decimal.js'
import Breadcrumbs from '../../components/Breadcrumbs.vue'

export default {
	name: 'RiwayatWithdrawalTunai',

	components: {
		Breadcrumbs,
	},

	data() {
		return {
			balanceHistory: [],
		}
	},

	created() {
		this.getLastTenTransactions()
	},

	computed: {
		streamingRate() {
			return this.$store.getters.getStreamingRate
		},
	},

	watch: {
		listWithdrawals() {
			this.withdrawals = this.listWithdrawals
		},

		search(newVal) {
			// search transactionId, amount, credit rped number, credit acount name, debit account name
			this.withdrawals = this.listWithdrawals.filter((withdrawal) => {
				return withdrawal.transactionId.includes(newVal)
			})
		}
	},

	methods: {
		getLastTenTransactions() {
			api.post('/v2/igx/last_transactions?skip=0&limit=10&type=bank', {
				user_id: this.$store.state.userId
			}).then(response => {
				let streamingRate = 1
				if (this.currency == 'usd') {
					streamingRate = this.streamingRate.streamSell
				}

				let history = response.data.data.body
				for (let i = 0; i < 10; i++) {
					if (!history[i]) {
						break
					}

					let dateTemp = new Date(history[i].created_at)
					let date = {
						year: dateTemp.getFullYear(),
						month: (dateTemp.getMonth() + 1 < 10) ? `0${dateTemp.getMonth() + 1}` : dateTemp.getMonth() + 1,
						date: (dateTemp.getDate() < 10) ? `0${dateTemp.getDate()}` : dateTemp.getDate(),
						hours: (dateTemp.getHours() < 10) ? `0${dateTemp.getHours()}` : dateTemp.getHours(),
						minutes: (dateTemp.getMinutes() < 10) ? `0${dateTemp.getMinutes()}` : dateTemp.getMinutes()
					}

					let indexOfStart = history[i].reff_transaction.indexOf("-")
					let transactionId = history[i].reff_transaction.substring(indexOfStart + 1)

					let debit = history[i].type == 'debit' ? Decimal.mul(history[i].amount, -1).dividedBy(streamingRate).toFixed(2) : '-'
					let credit = history[i].type == 'credit' ? Decimal.div(history[i].amount, streamingRate).toFixed(2) : '-'

					let amount
					if (history[i].type == 'debit') {
						amount = Decimal.mul(history[i].amount, -1).dividedBy(streamingRate).toFixed(2)
					} else {
						amount = Decimal.div(history[i].amount, streamingRate).toFixed(2)
					}

					this.balanceHistory.push({
						date: `${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}`,
						transactionId: transactionId,
						debit: debit,
						credit: credit,
						amount: amount,
					})
				}

				console.log('berhasil get last 10 transactions', response)
			})
		},
	}
}
</script>

<style scoped></style>